package com.ijoin.data.model

import kotlinx.serialization.Serializable

/**
 * Legal document content and metadata.
 */
@Serializable
data class LegalDocument(
    val type: String,
    val version: String,
    val content: String,
    val title: String
)

/**
 * User's legal document acceptance status.
 */
@Serializable
data class LegalAcceptanceStatus(
    val allAccepted: Boolean,
    val requiredVersions: Map<String, String>,
    val acceptedStatus: Map<String, Boolean>,
    val pendingDocuments: List<String>,
    val canCreateEvents: Boolean = true,
    val canPublishEvents: Boolean = true
)

/**
 * Request to accept legal documents.
 */
@Serializable
data class AcceptLegalDocumentsRequest(
    val documentTypes: List<String>,
    val versions: Map<String, String>? = null
)

/**
 * Types of legal documents.
 */
enum class LegalDocumentType(
    val apiName: String,
    val displayKey: String
) {
    TERMS_OF_SERVICE("TERMS_OF_SERVICE", "termsOfService"),
    PRIVACY_POLICY("PRIVACY_POLICY", "privacyPolicy"),
    REFUND_POLICY("REFUND_POLICY", "refundPolicy"),
    ORGANIZER_TERMS("ORGANIZER_TERMS", "organizerTerms"),
    AI_DATA_CONSENT("AI_DATA_CONSENT", "aiDataConsent");

    companion object {
        /**
         * Document types required for user registration.
         */
        val REGISTRATION_TYPES = listOf(
            TERMS_OF_SERVICE,
            PRIVACY_POLICY,
            REFUND_POLICY
        )

        /**
         * Parse from API name.
         */
        fun fromApiName(name: String): LegalDocumentType? {
            return entries.find { it.apiName == name }
        }
    }
}
